// Custom validator function to trim starting spaces if no characters present
export const validateSpaces = (_, value) => {
    if (value && value.trim() === '') {
        return Promise.reject('Space is not allowed at the beginning.')
    }
    return Promise.resolve()
}
